export const WHATSAPP_ABOUT_ENCRYPTION_URL = 'https://faq.whatsapp.com/820124435853543'

export const WHATSAPP_SUPPORTED_AUDIO_CONTENT_TYPES = new Set([
  'audio/mp3',
  'audio/ogg',
  'audio/wav',
  'audio/mpeg',
  'audio/flac',
  'audio/aac',
  'audio/m4a',
  'audio/mp4',
  'audio/x-m4a',
]);

export const WHATSAPP_SUPPORTED_IMAGE_CONTENT_TYPES = new Set([
  'image/png',
  'image/gif',
  'image/jpeg',
  'image/webp',
]);

export const WHATSAPP_SUPPORTED_VIDEO_CONTENT_TYPES = new Set([
  'video/mp4',
]);

// Edit Window specifies how long a message can be edited for after it was sent.
export const WHATSAPP_MESSAGE_EDIT_WINDOW = 20;// in minutes
